import {useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupAccount } from "src/components/Shared/NewForms/NFLookupAccount";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFPlainText } from "src/components/Shared/NewForms/NFPlainText";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";


export const AssemblyDisassemblyOfGOodsDetailProducts = () => {
    const tableName = "productsMaterials";
    const {setValue, getValues} = useFormContext();
    const {t} = useTranslation();

    return (
        <>
            <NFormTable fieldArray={tableName}>
                <NFLookupProduct title={t("Product")} fieldName="productId" width={200}/>
                <NFPlainText title={t("ProductVendorCode")} fieldName="productVendorCode"/>
                <NFLookupUnit fieldName={"unitId"} title={t("Unit")} width={200}/>
                <NFIntInput fieldName={"quantity"} title={t("Quantity")}/>
                <NFIntInput title={t("Coefficient")} fieldName="coefficient"/>
                <NFLookupAccount title={t("AccountingAccountId")} fieldName="accountingAccountId"/>
            </NFormTable>
        </>
    );
};
